export default "__VITE_ASSET__6b890df7__"